import { IngredientCaloriesCard } from 'components/desktop/Ingredient/Cards/IngredientCaloriesCard';
import { IngredientCategoryCard } from 'components/desktop/Ingredient/Cards/IngredientCategoryCard';
import { IngredientCharacteristicsCard } from 'components/desktop/Ingredient/Cards/IngredientCharacteristicsCard';
import { IngredientNutriScoreCard } from 'components/desktop/Ingredient/Cards/IngredientNutriScoreCard';
import { IngredientNutritionDiagramCard } from 'components/desktop/Ingredient/Cards/IngredientNutritionDiagramCard';
import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import IngredientNutrients from 'components/desktop/Ingredient/LanguageInput/IngredientNutrients';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import ENTITLEMENTS from 'enums/entitlements';

const TabNutrients = (props: IngredientTabProps) => {
	const { state, handlers, data } = props;

	return (
		<div className="row mt-4">
			<div className="col-md-4 col-xl-3 col-sm-12 col-12 sidebar">
				<IngredientCharacteristicsCard {...props} />
				<IngredientCategoryCard {...props} />
				<IngredientCaloriesCard {...props} />
				<RenderIf entitlements={[ENTITLEMENTS.NUTRI_SCORE]}>
					<IngredientNutriScoreCard {...props} />
				</RenderIf>
				<IngredientNutritionDiagramCard {...props} />
			</div>

			<div className="col-md-8 col-xl-9 col-sm-12 col-12">
				<IngredientNutrients
					characteristic={state.characteristic}
					allNutrients={data.nutrients}
					ingredientNutrients={state.nutrients}
					baseIngredientNutrients={state.baseIngredientNutrients}
					setNutrients={handlers.setNutrients}
				/>
			</div>
		</div>
	);
};

export default TabNutrients;
